import { Component, EventEmitter, Output } from '@angular/core';
import { OilCollectionService } from '../../../../services/customers/oil-collection.service';
import { DialogsService } from '../../../../services/dialogs.service';

@Component({
    selector: 'app-oil-collection-summary',
    templateUrl: './oil-collection-summary.component.html',
    styleUrls: ['./oil-collection-summary.component.scss'],
    standalone: false
})
export class OilCollectionSummaryComponent {
  loading = false;
  reportData: any = null;
  collections: any[] = [];
  dateRange = '';
  totalCollected = 0;
  totalCleaned = '';
  totalCost = '';
  clients: any[] = [];
  reloadSignal: boolean = false;
  @Output() cambioHijo: EventEmitter<void> = new EventEmitter<void>();

  public payload: any = {
    startDate: '2024-01-01',
    endDate: '2025-12-31',
    clients: [
      /* "62d2313147a2c6483dd1cb3d",
      "6388d4b21e4fe777bc93eb1b",
      "62d2313147a2c6483dd1ca47",
      "62d2313147a2c6483dd1c9e2",
      "62d2313147a2c6483dd1cb59",
      "62d2313147a2c6483dd1cc98",
      "62d2313147a2c6483dd1ca4e",
      "62d2313147a2c6483dd1c973",
      "62d2313147a2c6483dd1c989",
      "62d2313147a2c6483dd1c9e0",
      "62d2313147a2c6483dd1c9f4",
      "62d2313147a2c6483dd1ca2f",
      "62d2313147a2c6483dd1ca36",
      "62d2313147a2c6483dd1ca44",
      "62d2313147a2c6483dd1ca46",
      "642ebb2ab79ab1e3a99fabf3",
      "62d2313147a2c6483dd1ca59",
      "62d2313147a2c6483dd1ca5a",
      "62d2313147a2c6483dd1ca67",
      "62d2313147a2c6483dd1c94e",
      "62d2313147a2c6483dd1c971",
      "62d2313147a2c6483dd1c98c",
      "62d2313147a2c6483dd1cad1",
      "62d2313147a2c6483dd1c996" */
    ]
  };

  constructor(
    private oilCollectionService: OilCollectionService,
    private dialogsService: DialogsService,
  ) { }

  ngOnInit() {
    //this.loadReportData();
  }

  loadReportData() {
    this.loading = true;
console.log('test')
    this.oilCollectionService.getOilCollectionReportData(this.payload)
      .subscribe(
        (response: any) => {
          if (response.ok) {
            this.reportData = response.data;
            this.collections = response.data.collections;
            this.dateRange = response.data.reportInfo.dateRange;
            this.totalCollected = response.data.reportInfo.totalCollected;
            this.totalCleaned = response.data.reportInfo.totalCleaned;
            this.totalCost = response.data.reportInfo.totalCost;
          }
          console.log('pk')
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
        }
      );
  }

  async downloadReport() {
    return await this.oilCollectionService
      .exportOilColletionsReportExcel(this.payload)
      .then((res: any) => {
        if (res.doc) {
          const link = document.createElement('a');
          link.href = res.doc;
          link.download = 'Oil-Collection-Report.xlsx';
          link.click();
        }
      })
  }

  onFilterChange(event: any) {
    console.log(event)
  }

  openExportModal() {
    console.log('openExportModal', this.payload)
    this.dialogsService.openExportOilCollectionsReportExcel()
    .then((filterData: any) => {
      if (filterData) {
        // Update the payload with the new filter data
        this.payload = {
          startDate: filterData.startDate,
          endDate: filterData.endDate,
          clients: filterData.clientIds
        };
        this.loadReportData();
         console.log('El hijo ha cambiado. Emitiendo evento.');
    // Emite el evento para notificar al padre
        this.reloadSignal = !this.reloadSignal;
      }
    }).catch((error: any) => {
      // Modal was dismissed without data
      console.log('Modal dismissed');
    });
  }

  getTotalCollections(): number {
    return this.collections.filter(c => !c.isTotalRow).length;
  }

}